import {SHOW_MODAL_VAL} from '../action-creators/create-commodity';
import {CLOSE_MODAL_VAL} from '../action-creators/create-commodity';


const createCommodityReducers = (state={comModVal:false}, action) => {
	console.log(action.type);
	switch(action.type) {
		case SHOW_MODAL_VAL:
              console.log(`${SHOW_MODAL_VAL} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
               return action.payload; 
          case CLOSE_MODAL_VAL:
               console.log(`${CLOSE_MODAL_VAL} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
               return action.payload;         
           default:
               console.log(`${CLOSE_MODAL_VAL} reducer state:${JSON.stringify(state)}`);
               return state;
	}
}

export default createCommodityReducers;